import { LinearProgress } from '@mui/material';
import { useNavigation } from 'react-router';

export function NavigationProgress() {
  const { state } = useNavigation();

  if (state === 'idle') {
    return null;
  }

  return (
    <LinearProgress
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.drawer + 2,
        height: 3,
      }}
    />
  );
}
